import * as actions from '@actions'
import './LegalDescription.css'
import LegalDescriptionWrapper from './LegalDescriptionWrapper'

const legalEmptyEntry = documentId => order => ({
    documentId,
    original: '',
    summary: '',
    order,
})

const LegalDescriptionModal = ({ open, setOpen, document = {} }) => {
    
    const onClose = () => setOpen(false)
    
    const onSave = filteredLegals => {
        actions.saveLegalDescriptions(document.id, filteredLegals)
        onClose()
    }
    
    return (
        <LegalDescriptionWrapper
            open={open}
            hasVisible={false}
            legals={document.legalDescriptions}
            onClose={onClose}
            onSave={onSave}
            emptyEntryGenerator={legalEmptyEntry(document.id)} />
    )
}

export default LegalDescriptionModal
